// handles vote coloring and text generation to reduce code duplication.
export const VOTE_THRESHOLDS = {
    VERY: 25,
    OVERWHELMING: 50
};

// the order of this is important. Look at the find assessment function any you will see why
export const ASSESSMENTS = [
    { minPercent: 95, minVotes: VOTE_THRESHOLDS.OVERWHELMING, assess: "Overwhelmingly Positive", color: "limegreen" },
    { minPercent: 85, minVotes: VOTE_THRESHOLDS.VERY, assess: "Very Positive", color: "limegreen" },
    { minPercent: 80, minVotes: 1, assess: "Positive", color: "limegreen" },
    { minPercent: 70, minVotes: 1, assess: "Mostly Positive", color: "darkgreen" },
    { minPercent: 50, minVotes: 1, assess: "Mixed", color: "darkorange" },
    { minPercent: 20, minVotes: 1, assess: "Mostly Negative", color: "darkred" },
    { minPercent: 0, minVotes: VOTE_THRESHOLDS.OVERWHELMING, assess: "Overwhelmingly Negative", color: "red" },
    { minPercent: 0, minVotes: VOTE_THRESHOLDS.VERY, assess: "Very Negative", color: "red" },
    { minPercent: 0, minVotes: 1, assess: "Negative", color: "red" },
];

export function findAssessment(percent, totalVotes) {
    for (const { minPercent, minVotes, assess, color } of ASSESSMENTS) {
        if (percent >= minPercent && totalVotes >= minVotes) {
            return { assess, color };
        }
    }
    return { assess: "None", color: "gray" };
}
